import * as Yup from "yup";

interface ICloserCode extends Yup.MixedSchema {
  name: string;
  displayName: string;
  archiveDuration: string;
  archiveDurationPeriod: string;
  deletionDuration: string;
  deletionDurationPeriod: string;
  isStartFromCaseClosedDate: boolean;
  description: string;
}

const AddCloserCodeSchema = Yup.object<ICloserCode>().shape({
  name: Yup.string().required("US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
  displayName: Yup.string().required("US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
  description: Yup.string().required("US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
  archiveDuration: Yup.string().required("US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
  deletionDuration: Yup.string().required("US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
  isStartFromCaseClosedDate: Yup.boolean().required(
    "US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
  ),
});

export default AddCloserCodeSchema;
